module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting "
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.texts.Title)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option tabs"
  }, _vm._l((_vm.item.items), function(options, index) {
    return _c('button', {
      key: options.id,
      staticClass: "tab-btn",
      class: {
        active: (_vm.item.selected === index)
      },
      attrs: {
        "type": "button",
        "value": index
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.item.selected = index
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t(options.name)) + "\n            ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c87b7ed","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/input.tabs.vue
// module id = 234
// module chunks = 0